module.exports = __webpack_public_path__ + "img/close-btn.a927350e.svg";